import {UIDHeaderController} from '../../ui_html/header/UIDHeaderController'
import {UIWHeaderController} from '../../ui_html/header/UIWHeaderController'
import {UIDLeaderboardController} from '../../ui_leaderboard/UIDLeaderboardController'

export class UIDLeaderboardSceneController {
    private readonly headerController: UIWHeaderController
    private readonly leaderboardController: UIDLeaderboardController
    private readonly leaderboardSceneContainerDiv: HTMLDivElement
    private hasFetched: boolean

    constructor(headerController: UIWHeaderController) {
        this.headerController = headerController
        this.leaderboardController = new UIDLeaderboardController()
        this.leaderboardSceneContainerDiv = document.getElementById('scene_discord_leaderboard_container') as HTMLDivElement
        this.hasFetched = false
    }

    hide() {
        this.leaderboardSceneContainerDiv.classList.add('hidden')
    }

    async show() {
        this.leaderboardSceneContainerDiv.classList.remove('hidden')
        if(this.headerController instanceof UIDHeaderController) this.headerController.activateLeaderboardButton()

        if(this.hasFetched) return

        await this.leaderboardController.fetchStickyRowData()
        this.hasFetched = true
        this.leaderboardController.showChangeRegionIncentivePopup()
    }
}
